// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o3hl","content":"styles_content__2S2V_","tableWrap":"styles_tableWrap__y9DHq"};